import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../WhoWe_About/WhoWe_About.css'
import About3 from '../../../Img/about-3.jpg'
import About4 from '../../../Img/about-4.jpg'
import AboutShape2 from '../../../Img/shape/about-shape2.png'
import { useState } from 'react'
import { FaUserCircle, FaCalendar } from 'react-icons/fa';

const WhoWe_About = () => {
    const [toggle, setToggle] = useState(1)
    function updateToggle(id) {
        setToggle(id)
    }
    return (
        // <!-- About Start -->
        <div class="section harsafe-about-section-07 section-padding">
            <div class="shape-1"></div>
            <div class="container">
                {/* <!-- About Wrapper Start --> */}
                <div class="about-wrap">
                    <div class="row">
                        <div class="col-lg-6">
                            {/* <!-- About Image Wrap Start --> */}
                            <div class="about-img-wrap">
                                <img class="shape-1" src={AboutShape2} alt="" />
                                <div class="about-img">
                                    <img src={About3} alt="" />
                                </div>
                                <div class="about-img about-img-2">
                                    <img src={About4} alt="" />
                                </div>
                            </div>
                            {/* <!-- About Image Wrap End --> */}
                        </div>
                        <div class="col-lg-6">
                            {/* <!-- About Content Wrap Start --> */}
                            <div class="about-content-wrap">
                                <div class="section-title">
                                    <h3 class="sub-title">Who we are</h3>
                                    <h2 class="title">Innovating Digital Solutions for a Better Tomorrow</h2>
                                </div>
                                <p class="text">Providing cutting-edge services that enhance security, communication, and digital experiences for all.

                                </p>
                                {/* <!-- About List Start --> */}
                                <div class="about-list-03">

                                    <div class="row">
                                        <div class="col-md-3">
                                            {/* <!-- Tabs nav --> */}
                                            <div class="nav flex-column nav-pills nav-pills-custom" id="v-pills-tab"
                                                role="tablist" aria-orientation="vertical">

                                                <a class="nav-link mb-3 p-3 shadow active" id="v-pills-mission-tab"
                                                    data-bs-toggle="tab" data-bs-target="#v-pills-mission" role="tab"
                                                    aria-controls="v-pills-mission" aria-selected="true" onClick={() => updateToggle(1)} className={toggle === 1 ? "nav-link mb-3 p-3 shadow active" : "nav-link mb-3 p-3 shadow"}>
                                                    Mission
                                                    {/* <!-- <FaUserCircle /> */}
                                                    {/* <span class="font-weight-bold small text-uppercase">Mission</span> */}
                                                </a>

                                                <a class="nav-link mb-3 p-3 shadow" id="v-pills-vision-tab"
                                                    data-bs-toggle="tab" data-bs-target="#v-pills-vision" role="tab"
                                                    aria-controls="v-pills-vision" aria-selected="false" onClick={() => updateToggle(2)} className={toggle === 2 ? "nav-link mb-3 p-3 shadow active" : "nav-link mb-3 p-3 shadow"}>
                                                    Vision
                                                    {/* <!-- <FaCalendar /> */}
                                                    {/* <span class="font-weight-bold small text-uppercase">Vision</span>  */}
                                                </a>

                                            </div>
                                        </div>


                                        <div class="col-md-9">
                                            {/* <!-- Tabs content --> */}
                                            <div class="tab-content" id="v-pills-tabContent">
                                                <div class="tab-pane fade shadow rounded bg-white show active p-3"
                                                    id="v-pills-mission" role="tabpanel"
                                                    aria-labelledby="v-pills-mission-tab" tabindex="0" className={toggle === 1 ? "tab-pane fade shadow rounded bg-white p-3 show active" : "tab-pane fade shadow rounded bg-white p-3"}>
                                                    <h4 class="font-italic mb-4">Our Mission</h4>
                                                    <p class="font-italic text-muted mb-2">Our mission is to empower businesses and individuals through secure, innovative digital solutions, fostering growth, efficiency, and ease in every aspect of life, from communication to financial management.

                                                    </p>
                                                </div>

                                                <div class="tab-pane fade shadow rounded bg-white p-3" id="v-pills-vision"
                                                    role="tabpanel" aria-labelledby="v-pills-vision-tab" tabindex="0" className={toggle === 2 ? "tab-pane fade shadow rounded bg-white p-3 show active" : "tab-pane fade shadow rounded bg-white p-3"}>
                                                    <h4 class="font-italic mb-4">Our Vision</h4>
                                                    <p class="font-italic text-muted mb-2">To be a global leader in technology, providing groundbreaking solutions that drive digital transformation, enhance user experiences, and create lasting impact across industries and communities.</p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>



                                    {/* <div class="row">
                                        <div class="col-sm-6">
                                            <div class="about-list-item-03">
                                                <h3 class="title">Our Mission</h3>
                                                <p>Accelerate innovation with world-class tech teams. We help businesses elevate their value.</p>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="about-list-item-03">
                                                <h3 class="title">Custom Code</h3>
                                                <p>Accelerate innovation with world-class tech teams. We help businesses elevate their value.</p>
                                            </div>
                                        </div>
                                    </div>  */}
                                </div>
                                {/* <!-- About List End --> */}
                            </div>
                            {/* <!-- About Content Wrap End --> */}
                        </div>
                    </div>
                </div>
                {/* <!-- About Wrapper End --> */}
            </div>
        </div>
        // {/* <!-- About End --> */}
    )
}

export default WhoWe_About